import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

export const SANITIZE_PROFILE_RESTRICTED: SanitizationOption = {
  allowedAttributes: {},
  allowedSchemes: [],
  allowedTags: ['p', 'div', 'br'],
};
